import user from "./user";
import order from "./order";
import activity from "./activity";
import movie from './movie';
import ticket from './ticket';
import coffee from './coffee';
import external from './external';
import book from './book';
import cake from './cake'

export default [...user, ...order, ...activity,...movie,...ticket,...coffee,...external,...book,...cake];
